import React from "react";
import { useNavigate } from "react-router-dom";

import EmptyStateCard from "../../../components/EmptyStateCard";

const CartIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M3 4h2.2l2.3 10.6h10l2-7.2H7" />
    <circle cx="9.5" cy="19" r="1.4" />
    <circle cx="16.5" cy="19" r="1.4" />
  </svg>
);

const EmptyCartView = () => {
  const navigate = useNavigate();

  return (
    <EmptyStateCard
      icon={<CartIcon />}
      title="Your cart is empty"
      body="Browse cylinders from suppliers near you, or pick up an accessory to get started."
      actions={
        <>
          <button
            type="button"
            className="sy-flow-btn sy-flow-btn-ghost"
            onClick={() => navigate("/accessories")}
          >
            Browse accessories
          </button>
          <button
            type="button"
            className="sy-flow-btn sy-flow-btn-primary"
            onClick={() => navigate("/")}
          >
            Browse cylinders
          </button>
        </>
      }
    />
  );
};

export default EmptyCartView;
